var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewQc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.63699 10.5L0.666992 12.8333V2.49999C0.666992 2.32318 0.73723 2.15361 0.862254 2.02859C0.987279 1.90357 1.15685 1.83333 1.33366 1.83333H11.3337C11.5105 1.83333 11.68 1.90357 11.8051 2.02859C11.9301 2.15361 12.0003 2.32318 12.0003 2.49999V10.5H3.63699ZM3.17566 9.16666H10.667V3.16666H2.00033V10.09L3.17566 9.16666ZM5.33366 11.8333H12.1583L13.3337 12.7567V5.83333H14.0003C14.1771 5.83333 14.3467 5.90357 14.4717 6.02859C14.5968 6.15361 14.667 6.32318 14.667 6.5V15.5L11.697 13.1667H6.00033C5.82351 13.1667 5.65395 13.0964 5.52892 12.9714C5.4039 12.8464 5.33366 12.6768 5.33366 12.5V11.8333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewQc);
export default __webpack_public_path__ + "static/media/newQc.6809fa05a306bd851cab46199496ff83.svg";
export { ForwardRef as ReactComponent };